var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImprove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-928.000000, -1218.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-it-works",
    transform: "translate(0.000000, 980.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups",
    transform: "translate(186.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Act",
    transform: "translate(734.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "028-chat-bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.126582, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6979435,2.98475287 L12.6979435,0 L0,0 L0,8.64931593 L2.11989517,8.64931593 L2.11989517,12.0152471 L5.58686659,9.51211581 L5.58686659,11.6340688 L11.5026455,11.6340688 L16.164915,15 L16.164915,11.6340688 L18.2848101,11.6340688 L18.2848101,2.98475287 L12.6979435,2.98475287 Z M5.58686659,8.18070142 L3.19127077,9.90991425 L3.19127077,7.56539647 L1.07137559,7.56539647 L1.07137559,1.08391945 L11.6265679,1.08391945 L11.6265679,2.98475287 L5.58686659,2.98475287 L5.58686659,8.18070142 Z M17.2134345,10.5501493 L15.0935394,10.5501493 L15.0935394,12.8946671 L11.8458428,10.5501493 L6.65824219,10.5501493 L6.65824219,4.06867232 L11.6265679,4.06867232 L12.6979435,4.06867232 L17.2134345,4.06867232 L17.2134345,10.5501493 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImprove);
export default __webpack_public_path__ + "static/media/icon-improve.5c247e7c34731e0c592ccc42ca500489.svg";
export { ForwardRef as ReactComponent };